import { gsap } from 'gsap'
import { CustomEase } from 'gsap/CustomEase'

export default {
  data () {
    return {
      screen: undefined,
      timeline: undefined,
      scaleProperty: undefined,
      initialTransformOrigin: undefined,
      finalTransformOrigin: undefined,
      stagger: undefined,
      ease: CustomEase.create('custom', 'M0,0 C0,0 0.00803,0.16343 0.02359,0.26241 0.03528,0.33672 0.04691,0.38481 0.07146,0.45433 0.09102,0.50976 0.10899,0.54758 0.14127,0.59573 0.17603,0.64758 0.20631,0.68035 0.25235,0.72417 0.29499,0.76476 0.32677,0.79094 0.37697,0.82011 0.43466,0.85363 0.47691,0.86948 0.54247,0.89277 0.64558,0.9294 0.70952,0.95093 0.81445,0.97552 0.88353,0.99171 1,1 1,1 ')
    }
  },
  methods: {
    toggleMosaic (next) {
      gsap.timeline().fromTo('.mosaic > div', {
        [this.scaleProperty]: '0'
      },
      {
        duration: 0.3,
        [this.scaleProperty]: '1',
        transformOrigin: this.initialTransformOrigin,
        ease: this.ease,
        stagger: this.stagger,
        onComplete: () => { next() }
      })
    }
  },
  watch: {
    $route () {
      gsap.to('.mosaic > div', {
        [this.scaleProperty]: '0',
        duration: 0.3,
        transformOrigin: this.finalTransformOrigin,
        ease: this.ease,
        stagger: this.stagger,
        onComplete: () => {
          this.$root.$emit('transition-dismiss')
          gsap.set('.mosaic > div', { clearProps: 'all' })
        }
      })
    }
  }
}
